import 'idempotent-babel-polyfill';
import 'intersection-observer';
import 'core-js';
import 'custom-event-polyfill';
import 'whatwg-fetch';
import $ from 'jquery';
import './utils/jquery-events';
import _ from 'underscore';
import LazyLoad from './app/boot/lazy-load';
import InitData from './app/data/init-data';
import loadModules from './app/pages/load-modules';
import { loadModule, handleError } from 'utils/code-split';
import { MainNavigation } from 'containers';
import { bootLanguages } from 'static/script/app/lang';
import { bootFooterLocalization } from 'core/script/app/boot/boot-footer-language-link';
import GdprMount from 'tradera-components/alerts/gdpr/gdpr-mount';

import 'core/style/master';
import 'core/style/_include-components';

window._ = window._ || _;
window.$ = window.$ || $;
const initData = InitData.currentOrSet();

bootLanguages();
MainNavigation();
LazyLoad();
bootFooterLocalization();

if (initData) {
    GdprMount(initData.featureSwitches);

    loadModules(initData)
        .then(module => {
            let ret = loadModule(module, initData);
            window.document.body.setAttribute('data-module-loaded', 'true');
            return ret;
        })
        .catch(err => handleError(err));
}
